"use client";
import {
  // eslint-disable-next-line no-restricted-imports
  useRouter as useNextRouter,
} from "next/navigation";
// import {
//   AppRouterInstance,
//   NavigateOptions,
// } from "next/dist/shared/lib/app-router-context";
import { useRouterChange } from "./useRouterChange";
import { useAtom } from "jotai";
import { progressAtom } from "@/hooks/headerHooks";
import {
  AppRouterInstance,
  NavigateOptions,
} from "next/dist/shared/lib/app-router-context.shared-runtime";

export const useRouter = (): AppRouterInstance => {
  const router = useNextRouter();
  const routerChange = useRouterChange();
  const [, setProgress] = useAtom(progressAtom);

  const push = (
    href: string,
    options?: NavigateOptions & { saveScrollPosition?: boolean },
  ) => {
    routerChange.setRouterChange(href);
    if (!options?.saveScrollPosition)
      sessionStorage.removeItem("scrollPosition");
    router.push(href, options);
  };
  const replace = (href: string, options?: NavigateOptions) => {
    routerChange.setRouterChange(href);
    router.replace(href, options);
  };
  const back = () => {
    router.back();
    setProgress(true);
  };
  return {
    push,
    replace,
    back,
    refresh: router.refresh,
    prefetch: router.prefetch,
    forward: router.forward,
  };
};
